import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Drop the static LCP shell as soon as React has painted (don't wait for hero effect).
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    document.getElementById("lcp-shell")?.remove();
  });
});
window.setTimeout(() => {
  document.getElementById("lcp-shell")?.remove();
}, 1500);
